import type { RibbonControlProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { type MailRibbonControlId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { debugErrorThatWillShowErrorPopupOnly } from 'owa-trace';
import { getFolderPaneControl } from '../../sharedControls/readSharedControlDefinitions';

export const getMLRFolderTabControlDefinition: (
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlProps | undefined = owaComputedFn(function getMLRFolderTabControlDefinition(
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): RibbonControlProps | undefined {
    switch (controlId) {
        case 647:
            return getFolderPaneControl(false /* isSLR */, 17, props);
        default:
            debugErrorThatWillShowErrorPopupOnly(
                'getMLRFolderTabControlDefinition UnknownControl: ' + controlId
            );
            return undefined;
    }
});
